import PropTypes from 'prop-types';
import React from 'react';
import './ThreeColumnLayout.scss';

export default function ThreeColumnLayout(props, context) {
    const showRightRailCss = props.shouldShowRightRailMobile
        ? 'show-right-rail'
        : '';

    return (
        <div
            className={`component-Layout-ThreeColumnLayout ${showRightRailCss} ${
                context?.leadInLogin ? 'leadInLogin' : ''
            }`}
        >
            {props.children}
        </div>
    );
}

ThreeColumnLayout.propTypes = {
    shouldShowRightRailMobile: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

ThreeColumnLayout.defaultProps = {
    shouldShowRightRailMobile: false,
};

ThreeColumnLayout.RightRail = ({ children, stickyContent }) => {
    if (stickyContent) {
        const { ref, styles } = stickyContent;
        return (
            <div className="ThreeRailLayout-RailRail" ref={ref} style={styles}>
                {children}
            </div>
        );
    }
    return <div className="ThreeRailLayout-RailRail">{children}</div>;
};

ThreeColumnLayout.MainContent = ({ children, stickyContent }) => {
    if (stickyContent) {
        const { ref } = stickyContent;
        return (
            <div className="ThreeRailLayout-MainContent" ref={ref}>
                {children}
            </div>
        );
    }
    return <div className="ThreeRailLayout-MainContent">{children}</div>;
};

ThreeColumnLayout.LeftRail = ({ children, stickyContent }) => {
    if (stickyContent) {
        const { ref, styles } = stickyContent;
        return (
            <div className="ThreeRailLayout-LeftRail" ref={ref} style={styles}>
                {children}
            </div>
        );
    }
    return <div className="ThreeRailLayout-LeftRail">{children}</div>;
};
